export default {
  getFileDetails: state => (ids => ids.map(id => state.files[id])),
};
